import { defineField, defineType } from "sanity";

export const educationSettingsType = defineType({
  type: "document",
  name: "educationSettings",
  title: "Education Settings",
  fields: [
    defineField({
      name: "title",
      type: "string",
      hidden: true,
      validation: (Rule) => Rule.required()
    }),
    // custom component button "sync videos with sanctuary health"
    defineField({
      name: "syncVideos",
      type: "syncVideosSanctuaryHealth",
      title: "Sync Videos with Sanctuary Health"
    })
  ]
});
